import { ProcessDetailsWorkflow } from '@/modules/Processes/domain';
import { useWorkflowsDragAndDrop } from '@/modules/Processes/hooks/useWorkflowsDragAndDrop';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { WorkflowTasksTable } from './WorkflowTaskTable';

type WorkflowsTableProps = {
  initialWorkflows: ProcessDetailsWorkflow[];
  isLoadingWorkflows: boolean;
  businessAreaId: number;
};

export const WorkflowsTable = ({
  initialWorkflows,
  isLoadingWorkflows,
  businessAreaId,
}: WorkflowsTableProps) => {
  const {
    workflows,
    onDragEnd,
    onDragOver,
    isSubmittingOrderTasks,
    isSubmittingOrderWorkflows,
  } = useWorkflowsDragAndDrop({ initialWorkflows });

  return (
    <>
      <div>
        <DndContext
          onDragEnd={onDragEnd}
          onDragOver={onDragOver}
          modifiers={[restrictToVerticalAxis]}
        >
          <SortableContext
            id="workflows"
            items={workflows.map((w) => `w_${w.id.toString()}`)}
            strategy={verticalListSortingStrategy}
          >
            {workflows.map((workflow) => (
              <WorkflowTasksTable
                key={workflow.id}
                workflow={workflow}
                businessAreaId={businessAreaId}
                isLoading={
                  isSubmittingOrderTasks ||
                  isSubmittingOrderWorkflows ||
                  isLoadingWorkflows
                }
              />
            ))}
          </SortableContext>
        </DndContext>
      </div>
    </>
  );
};
